import styled from 'styled-components';

export const CardContainer = styled.div``;

export const CardImage = styled.div`
  width: 100%;
  height: fit-content;
  background-image: url(${props => props.background});
  background-size: cover;
  background-repeat: no-repeat;
  display: flex;
  -webkit-box-pack: start;
  justify-content: flex-start;
  -webkit-box-align: center;
  align-items: center;
  background-position: ${props => props.imgPosition} center;
  padding: 10px;
  min-height: 350px;
`;

export const CardInfoContainer = styled.div`
  max-width: 100%;
  height: initial;
  min-height: 100px;
  padding: 40px 58px 20px 30px;
  background-color: rgb(255, 255, 255);
  position: relative;

  @media ${props => props.theme.device.mobile} {
    min-height: 100px;
  }
`;

export const CardTitle = styled.div`
  padding-bottom: 6px;
  word-break: break-word;
  color: ${props => props.theme.colors.primary.base};
`;

export const CardBody = styled.div``;

export const Icon = styled.span`
  font-size: 30px;
  margin: 20px;
  color: ${props => props.theme.colors.primary.base};
  position: absolute;
  top: 0;
  right: 0;
  cursor: pointer;

  &.small-icon {
    font-size: 18px;
  }

  &.align-left {
    margin-left: auto;
  }
`;

export const ButtonWrapper = styled.div`
  margin-top: 30px;
  max-width: 100%;
`;
